// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__245e2","row":"styles_row__D3TuU"};